import { DrugFoodInteraction, RequestResult } from "domain/entities/drug-food-interaction";
import { DrugFoodInteractionRepository } from "domain/repositories";

export default class CreateUseCase {
    private drugFoodInteractionRepository: DrugFoodInteractionRepository;
    
    public constructor(drugFoodInteractionRepository: DrugFoodInteractionRepository) {
        this.drugFoodInteractionRepository = drugFoodInteractionRepository
    }

    public async createDrugFoodInteraction(drugFoodInteraction: DrugFoodInteraction, token: Promise<[string | null, string | null]>): Promise<[RequestResult, null] | [null, Error]> {
        const [t, ] = await token;
        if (t !== null) {
            return this.drugFoodInteractionRepository.createDrugFoodInteraction(drugFoodInteraction, t);
        } else {
            return [null, new Error("Autenticación faltante")];
        }
    }
}